import React from 'react';
import styles from './styles.module.scss';
import UpdateNameModal from './UpdateNameModal';
import icVerified from 'assets/svg/ic_verified_V2.svg';
import icSetting from 'assets/svg/ic_setting_V2.svg';
import { useTypedSelector } from '@profile/src/redux/utils';
import classNames from 'classnames';

const AccountSetting = () => {
  const username = useTypedSelector(state => {
    var _state$userProfile$us;

    return (_state$userProfile$us = state.userProfile.user) === null || _state$userProfile$us === void 0 ? void 0 : _state$userProfile$us.username;
  });
  const email = useTypedSelector(state => {
    var _state$userProfile$us2;

    return (_state$userProfile$us2 = state.userProfile.user) === null || _state$userProfile$us2 === void 0 ? void 0 : _state$userProfile$us2.email;
  });
  const [openModal, setOpenModel] = React.useState(false);

  const onCloseModal = () => {
    setOpenModel(false);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("img", {
    src: icSetting,
    className: styles.icSetting
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, "Account Setting")), /*#__PURE__*/React.createElement("hr", {
    className: styles.horizonalBar
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.info
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, "Game Profile"), /*#__PURE__*/React.createElement("span", {
    className: styles.subTitle
  }, "Name"), /*#__PURE__*/React.createElement("div", {
    className: styles.nameStack
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.name
  }, username), /*#__PURE__*/React.createElement("button", {
    disabled: true,
    onClick: () => {
      setOpenModel(true);
    },
    className: styles.button
  }, "Change Name")), /*#__PURE__*/React.createElement("span", {
    className: classNames(styles.subTitle, styles.email)
  }, "Email Address"), /*#__PURE__*/React.createElement("div", {
    className: styles.emailGroup
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.email
  }, email), /*#__PURE__*/React.createElement("div", {
    className: styles.verified
  }, /*#__PURE__*/React.createElement("img", {
    src: icVerified,
    className: styles.icon
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.status
  }, "Verified")))), openModal && /*#__PURE__*/React.createElement(UpdateNameModal, {
    onClose: onCloseModal
  }));
};

export default AccountSetting;